/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowCircular16: {
  name: 'arrow-circular-16';
  data: string;
} = {
  name: 'arrow-circular-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.917 7h1.584a.503.503 0 0 1 .382.823l-2.5 2.998a.5.5 0 0 1-.766 0l-2.5-2.998A.502.502 0 0 1 10.498 7h1.375a4.002 4.002 0 0 0-6.23-2.232l-.726-.87a2.5 2.5 0 0 0-.682-.57A6.002 6.002 0 0 1 13.916 7zM2.083 9H.499a.5.5 0 0 1-.383-.823L2.617 5.18a.497.497 0 0 1 .765 0l2.501 2.998A.503.503 0 0 1 5.501 9H4.126a4.002 4.002 0 0 0 6.23 2.233l.726.869c.197.236.429.427.681.571A6.002 6.002 0 0 1 2.083 9z"/></svg>`
};
